export default {
	path: 'projects/:projectId',
	name: 'Project',
	component: () => import('@/views/project/Index'),
	redirect: { name: 'ReportsList' },
	meta: {
		dynamic: true,
	},
	children: [
		{
			path: 'reports',
			name: 'ReportsList',
			component: () => import('@/views/project/ReportsList'),
			meta: {
				title: 'Reports',
			},
		},
		{
			path: 'categories',
			name: 'Categories',
			component: () => import('@/views/project/Categories'),
			meta: {
				title: 'Categories',
			},
		},
		{
			path: 'keywords',
			name: 'Keywords',
			component: () => import('@/views/project/Keywords'),
			meta: {
				title: 'Keywords',
			},
		},
		{
			path: 'customdata',
			name: 'CustomData',
			component: () => import('@/views/project/CustomData'),
			meta: {
				title: 'Custom Data',
			},
		},
		{
			path: 'users',
			name: 'Users',
			component: () => import('@/views/project/Users'),
			meta: {
				title: 'Users',
			},
		},
		{
			path: 'outputs',
			name: 'ReportOutput',
			component: () => import('@/views/project/Outputs'),
			meta: {
				title: 'Outputs',
			},
		},
		{
			path: 'settings',
			name: 'ProjectSettings',
			component: () => import('@/views/project/Settings'),
			meta: {
				title: 'Settings',
			},
		},
		{
			path: 'overrides',
			name: 'Overrides',
			component: () => import('@/views/project/Overrides'),
			meta: {
				title: 'Overrides',
			},
		},
	],
};
